import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ContentElement, LinkTarget,GridCell, RowCell } from '../../../models/sections-model';
import { Router } from '@angular/router';

@Component({
  selector: 'kve-action-element',
  templateUrl: './action-element.component.html',
  styleUrls: ['./action-element.component.scss']
})

export class ActionElementComponent implements OnChanges{
  @Input() contentElement:ContentElement;
  @Input() cell:RowCell|GridCell
  url:string;

  constructor(private router:Router){}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["contentElement"]){
      if(this.contentElement.action){
        let linkTargetEnumValue = this.getEnumValue(this.contentElement.action);
        if(linkTargetEnumValue){
          switch (linkTargetEnumValue) {
            case "product":
              let productId = this.contentElement.productId;
              this.url = "/admin/blog/products/"+productId              
              break;
            case "category":
              let categoryId = this.contentElement.categoryId;
              this.url = "/admin/blog/article/"+categoryId              
              break;
            case "article":
              let articleContentId = this.contentElement.articleContentId
              this.url = "/admin/blog/article/"+articleContentId              
              break;
           default:
              break;
          }
        }
      }
          
    }
  }

  getEnumValue(linkTargetEnum:LinkTarget){
    let enumValue;
    if((linkTargetEnum).includes(".")){
      let enumKey = linkTargetEnum.split('.')[1] as keyof typeof LinkTarget;
      enumValue = LinkTarget[enumKey];
    }else if(LinkTarget[linkTargetEnum] != undefined){
      enumValue = LinkTarget[linkTargetEnum]
    }else{
      enumValue = linkTargetEnum;
    }
    return enumValue
  }

  routeAction(){
    this.router.navigateByUrl(this.url)
  }
}
